export default __webpack_public_path__ + "static/media/covid-19-china-lockdown.d3820768.png";